// Import Picsart Design System foundation tokens
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { ErrorColors } from '@picsart/design-system/foundation/errorColors';
import { PositiveColors } from '@picsart/design-system/foundation/positiveColors';
import { hideScrollbars } from '@picsart/design-system/foundation/hideScrollbars';

// Import canonical breakpoints
import { BREAKPOINTS } from '@/consts/breakpoints';

// Re-export breakpoints for component usage
export { BREAKPOINTS };

// Media queries
export const media = {
  desktop: `@media (min-width: ${BREAKPOINTS.desktop}px)`,
  largeDesktop: `@media (min-width: ${BREAKPOINTS.largeDesktop}px)`,
  wideDesktop: `@media (min-width: ${BREAKPOINTS.wideDesktop}px)`,
  ultraWide: `@media (min-width: ${BREAKPOINTS.ultraWide}px)`,
  mobile: `@media (max-width: ${BREAKPOINTS.desktop - 1}px)`,
  smallMobile: `@media (max-width: ${BREAKPOINTS.smallMobile - 1}px)`,
  narrow: `@media (max-width: ${BREAKPOINTS.narrow - 1}px)`,
};

// Spacing - mapped to Picsart Design System Spacings
export const spacing = {
  xs: Spacings.s4,
  sm: Spacings.s8,
  md: Spacings.s12,
  lg: Spacings.s16,
  xl: Spacings.s24,
  xxl: Spacings.s32,
};

// Colors - mapped to Picsart Design System tokens
export const colors = {
  background: BackgroundColors.base,
  backgroundSecondary: BackgroundColors.tint1,
  surface: BackgroundColors.base,
  surfaceSecondary: BackgroundColors.tint1,
  text: TextColors.base,
  textSecondary: TextColors.tint1,
  border: BackgroundColors.tint2,
  accent: PrimaryColors.base.default,
  accentHover: PrimaryColors.base.action,
  error: ErrorColors.base.default,
  success: PositiveColors.base.default,
};

// Border radius - mapped to Picsart Design System CornerRadius
export const radius = {
  sm: CornerRadius.r4,
  md: CornerRadius.r8,
  lg: CornerRadius.r12,
  xl: CornerRadius.r16,
  round: CornerRadius.circle,
};

// Shadows
export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
  md: '0 4px 8px rgba(0, 0, 0, 0.15)',
  lg: '0 8px 16px rgba(0, 0, 0, 0.2)',
};

// Z-index layers
export const zIndex = {
  base: 1,
  dropdown: 10,
  sticky: 100,
  modal: 1000,
  toast: 2000,
};

// Re-export Design System utilities
export { hideScrollbars, Spacings, CornerRadius, BREAKPOINTS as breakpoints };

export default {
  BREAKPOINTS,
  media,
  spacing,
  colors,
  radius,
  shadows,
  zIndex,
  hideScrollbars,
};
